// extracted by mini-css-extract-plugin
module.exports = {"spinner":"styles__spinner____YOfz","spinnerSpoke":"styles__spinnerSpoke___5vS8P","centered":"styles__centered___3YUCQ"};